import useSWR from "swr";
import axios from "axios";

function useLeaveRequests({ shouldFetch = true, labourerId, status, startDate, endDate, page, perPage, sortField, sortOrder }) {
  return useSWR(
    shouldFetch ? [
      `${process.env.REACT_APP_API_URL}/leave-requests`,
      labourerId, status, startDate, endDate, page, perPage, sortField, sortOrder
    ] : null,
    async ([url, labourerId, status, startDate, endDate, page, perPage, sortField, sortOrder]) => {
      const searchParams = new URLSearchParams();

      if (labourerId) searchParams.append('labourerId', labourerId);
      if (status) searchParams.append('status', status);
      if (startDate) searchParams.append('startDate', startDate);
      if (endDate) searchParams.append('endDate', endDate);
      if (page) searchParams.append('page', page);
      if (perPage) searchParams.append('perPage', perPage);
      if (sortField) searchParams.append('sortField', sortField);
      if (sortOrder) searchParams.append('sortOrder', sortOrder);

      const params = searchParams.toString();

      const { data: { leaveRequests, count } } = await axios.get(`${url}?${params}`);

      return { leaveRequests, count };
    });
}

export default useLeaveRequests;
